import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

export interface RouterState {
  pathname: string
  query: Record<string, string | string[]>
  asPath: string
}

const initialState: RouterState = {
  pathname: '',
  query: {},
  asPath: '',
}

export const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    setRouterState: (state, action: PayloadAction<RouterState>) => {
      state.pathname = action.payload.pathname
      state.query = action.payload.query
      state.asPath = action.payload.asPath
    },
    setPathname: (state, action: PayloadAction<string>) => {
      state.pathname = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.router,
      }
    })
  },
})

export const { setRouterState, setPathname } = routerSlice.actions

export default routerSlice.reducer
